import React, { useEffect, useState } from "react";
import { Box, Row, ColumnTow } from "../FooterStyles";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

function UpdateUserView({ user, prenom, nom, phone, saveUser }) {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [prenomx, setPrenom] = useState(prenom);
  const [nomx, setNom] = useState(nom);
  const [phonex, setPhone] = useState(phone);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        padding: size.width <= 428 ? 0 : " 45px 0px",
      }}
    >
      <Row>
        <p className="subtitle" style={{ paddingBottom: 30 }}>
          Mon email : {user && user.email}
        </p>
      </Row>
      <Row>
        <ColumnTow>
          <div className="lieu">
            <input
              value={prenomx}
              onChange={(e) => setPrenom(e.currentTarget.value)}
              className="oraleway-normal-silver-14px-nopadding"
              name="name"
              placeholder="Prénom"
              style={{ width: 264, fontSize: "16px" }}
              autoComplete="given-name"
            />
            <img
              className="ligne-2"
              style={{ width: 264 }}
              src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
              alt=""
            />
          </div>
        </ColumnTow>
        <ColumnTow>
          <div className="lieu">
            <input
              value={nomx}
              onChange={(e) => setNom(e.currentTarget.value)}
              className="oraleway-normal-silver-14px-nopadding"
              name="lastname"
              placeholder="Nom"
              style={{ width: 264, fontSize: "16px" }}
              autoComplete="family-name"
            />
            <img
              style={{ width: 264 }}
              className="ligne-2"
              src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
              alt=""
            />
          </div>
        </ColumnTow>
        <ColumnTow>
          <div className="date" style={{ marginBottom: 20 }}>
            {/* <input
              value={phonex}
              onChange={(e) => setPhone(e.currentTarget.value)}
              style={{ width: 264, fontSize: "16px" }}
              className="oraleway-normal-silver-14px-nopadding"
              name="phone"
              placeholder="Téléphone"
              autoComplete="tel"
              tel-country-code={262}
            /> */}
            <PhoneInput
              country="RE"
              defaultCountry="RE"
              name="phone"
              placeholder="Téléphone"
              value={phonex}
              style={{ width: 264, fontSize: "16px" }}
              className="oraleway-normal-silver-14px-nopadding"
              onChange={(e) => {
                setPhone(e);
                if (e != null) {
                  setMessage(isValidPhoneNumber(e) ? true : false);
                } else {
                  setMessage(null);
                }
              }}
            />
            <img
              style={{ width: 264 }}
              className="ligne-2-1"
              src={process.env.PUBLIC_URL + "/ligne-2-1.png"}
              alt=""
            />
            {message != null && (
              <span
                style={{
                  color: message ? "green" : "red",
                  fontSize: 10,
                }}
              >
                {message ? "Valide" : "Invalide"}
              </span>
            )}
          </div>
        </ColumnTow>
      </Row>
      <Row>
        <ColumnTow>
          <button
            class="bouton-plein border-1px-dove-gray"
            style={{
              height: 55,
              marginTop: "20px",
              background: loading && "white",
              border: loading && "white",
            }}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              saveUser(
                prenomx,
                nomx,
                isValidPhoneNumber(phonex) ? phonex : null,
                () => {
                  setLoading(false);
                }
              );
            }}
          >
            <div
              class="prendre-rdv raleway-semi-bold-white-18px"
              style={{
                color: loading && "black",
              }}
            >
              {loading ? "Chargement ..." : "Valider"}
            </div>
          </button>
        </ColumnTow>
        <div id="recaptcha-container" />
      </Row>
    </Box>
  );
}

export default UpdateUserView;
